import { View } from "extensions/marionette";

import sweetalert from "sweetalert";

import { UsersCollection } from "common/features/user/usersCollection";
import { UserModel } from "common/features/user/model";

import { userManagementMixin } from "./userManagementMixin";

import { SearchUsersInput } from "./search/searchUsers";
import usersTemplate from "./users.jst";

export const UsersView = View.extend({
    ...userManagementMixin,
    template: usersTemplate,
    
    regions: {
        list: ".list",
        search: ".search-filter"
    },
    
    tableMode() {
        return this.hasMerchantRef ? "client" : "server";
    },
    
    makeUsersCollection({ merchant_ref, name }) {
        this.users = new UsersCollection();
        if (merchant_ref) {
            this.hasMerchantRef = true;
            this.users.url = `/merchant/${merchant_ref}/users/`;
        } else {
            this.hasMerchantRef = false;
            this.users.url = "/users";
        }
    
        // Set default sort by settlement date
        this.users.setQueryParam({
            sort: "last_login",
            order: -1
        });
        
        // Set user query if supplied
        if (name) {
            // If name is Mongo Object ID then we can fetch info directly from /users/id
            if (/^(?=[\da-f]{24}$)(\d+[a-f]|[a-f]+\d)/i.test(name)) {
                const user = new UserModel({
                    _id: name
                });
                this.users.add(user);
                user.fetch({
                    error: () => {
                        this.users.reset();
                    }
                });
                
                return;
            }
            
            this.users.setQueryParam({ name });
        }
        
        this.users.fetch();
    },
    
    showSearchForm() {
        const search = new SearchUsersInput({
            merchant_ref: this.getOption("merchant_ref")
        });
        this.listenTo(search, "tokens:update", (tokens) => {
            const { value: merchant_ref } = tokens.find((token) => token.group === "merchant_ref") || {};
            const { value: name } = tokens.find((token) => token.group === "name") || {};
            this.makeUsersCollection({
                merchant_ref,
                name
            });
            this.makeList();
        });
        
        this.showChildView("search", search);
    },
    
    renderView() {
        this.makeUsersCollection({
            merchant_ref: this.getOption("merchant_ref")
        });
        
        // Show omni search bar
        this.showSearchForm();
        
        // Show all users list
        this.makeList();
    },
    
    columnsMapper(column) {
        if (column.attribute === "last_login") {
            return {
                sortOptions: {
                    active: "-1"
                },
                ...column
            };
        }
        
        return column;
    },
    
    createOrEditUser(model) {
        // Open merchant portal and show edit this user
        sweetalert({
            text: "Do you want to open Merchant portal and edit this user there?",
            icon: "warning",
            buttons: {
                confirm: {
                    text: "Totally",
                    className: "btn-confirm"
                },
                cancel: {
                    visible: true
                }
            }
        }).then((confirmed) => {
            if (confirmed) {
                window.open(`/merchant/preferences/users/users/${model.id}?merchant=${model.get("merchant_ref")}`);
            }
        });
    }
});
